import WhatIsTABOR from "./WhatIsTABOR"

export default WhatIsTABOR
